export const businessUnit = [
  { businessUnit: "Chassis" },
  { businessUnit: "PT" },
  { businessUnit: "Accessories" },
];

export const eolToolingApprover = {
  name: "Nick Seeman",
  email: "nick.seeman@polaris.com",
  role: "EOL Tooling Asset Manager",
};

export const pgaToolingApprover = {
  name: "Griffin Meuwissen",
  email: "griffin.meuwissen@polaris.com",
  role: "Service Manager",
};

export const toolSelectOptions = ["Search", "Write-In", "No tool Number"];
